import { render, staticRenderFns } from "./WaitCommonDetail.vue?vue&type=template&id=4f3ca227&"
import script from "./WaitCommonDetail.vue?vue&type=script&lang=js&"
export * from "./WaitCommonDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaitCommonDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports